// 261005 E4-P3 — chữ giá quét + quyết định nối job crawl → quét. KHÔNG import antd (jest của react-scripts không load được antd v6).
import type { AdaptationCrawlTaskDetail, CrawlProgressData, RawChapter, ScanEstimate } from '../../types/adaptation';

export const NO_MEASURE_TEXT = 'Chưa có số đo';
export const UNKNOWN_CHAPTERS_TEXT = 'Chưa rõ số chương — sẽ biết sau khi nạp';

/**
 * Câu ước giá. `null` = KHÔNG hiện (chưa gọi / 0 chương cần quét). Luôn có dấu "~": Gemini là ước tính từ giá niêm yết, không phải hoá đơn.
 */
// 261005 E5: User bỏ mọi số tiền khỏi giao diện ⇒ luôn null (giữ hàm để chỗ gọi / kiểu `ScanEstimate` không đổi).
export const scanEstimateText = (_est: ScanEstimate | null | undefined): string | null => null;

/** Sau "Dò thử": `totalChapters` null/≤0 ⇒ KHÔNG gọi `scan-estimate`, hiện câu "chưa rõ". */
export const canEstimateFromProbe = (totalChapters: number | null | undefined): totalChapters is number =>
  typeof totalChapters === 'number' && Number.isFinite(totalChapters) && totalChapters > 0;

/** "Sẽ là chương N (xếp cuối)" — N = max orderIndex + 1 của danh sách đang tải. */
export const nextChapterNumber = (raws: Array<Pick<RawChapter, 'orderIndex'>>): number =>
  raws.reduce((m, r) => Math.max(m, r.orderIndex || 0), 0) + 1;

/** Câu khi job quét xong (E5: không còn chi phí). */
export const scanDoneText = (_result: { totalCostUsd?: number } | null | undefined): string => 'Đã xong.';

export type CrawlTerminalDecision = { chainToScan: string } | null;

/**
 * B1: crawl `completed` + có `result.scanJobId` ⇒ nối sang theo dõi job quét (KHÔNG xoá `bgJob`). Mọi trường hợp khác ⇒ null (xử lý như cũ).
 */
export const decideCrawlTerminal = (
  outcome: string, currentKey: string | undefined, task: { detail?: unknown } | null | undefined,
): CrawlTerminalDecision => {
  if (outcome !== 'completed' || currentKey !== 'crawl') return null;
  const id = ((task?.detail ?? null) as AdaptationCrawlTaskDetail | null)?.result?.scanJobId;
  return typeof id === 'string' && id ? { chainToScan: id } : null;
};

/** F11: toast khi job nạp xong — nêu số chương thật ("Đã nạp 20 chương"), thay cho "Đã xong.". `chaining` = sắp tự quét. */
export const crawlDoneText = (result: Partial<CrawlProgressData> | null | undefined, chaining: boolean): string => {
  const tail = chaining ? ' · đang tự quét…' : '';
  if (!result || (result.created === undefined && result.fetched === undefined)) return `Đã nạp xong${chaining ? '' : '.'}${tail}`;
  const n = result.created ?? result.fetched ?? 0;
  if (n <= 0) return `${(result.skipped ?? 0) > 0 ? `Không có chương mới (đã có sẵn ${result.skipped})` : 'Không nạp được chương nào'}${tail}`;
  return `Đã nạp ${n} chương${(result.failed ?? 0) > 0 ? ` · hỏng ${result.failed}` : ''}${tail}`;
};
